import { NOVO_FILTRO_STATE, NOVO_FILTRO_STATE_CHANGE_COLOR, NOVO_FILTRO_MATRICULA_TECNICO_STATE, NOVO_FILTRO_SELECT_PERIODO_ANTERIOR, ROTA_DETALHAR, NOVO_FILTRO_OS_BD_STATE, NOVO_FILTRO_NUMERO_BA_STATE } from '../actions/actionTypes';
import initialState from './initialState';

export default function novoFiltroReducer(state = initialState.novoFiltro, action) {
    if (action.type === NOVO_FILTRO_STATE) {
        return { ...state, open: action.open };
    }

    if (action.type === NOVO_FILTRO_STATE_CHANGE_COLOR) {
        return { ...state, changeColor: action.changeColor };
    }

    if (action.type === NOVO_FILTRO_MATRICULA_TECNICO_STATE) {
        return { ...state, matriculaTecnico: action.matriculaTecnico };
    }

    if (action.type === NOVO_FILTRO_NUMERO_BA_STATE) {
        return { ...state, numeroBa: action.numeroBa };
    }

    if (action.type === NOVO_FILTRO_OS_BD_STATE) {
        return { ...state, osBd: action.osBd };
    }

    if (action.type === NOVO_FILTRO_SELECT_PERIODO_ANTERIOR) {
        return { ...state, selectPeriodoAnterior: action.selectPeriodoAnterior };
    }

    if (action.type === ROTA_DETALHAR) {
        return { ...state, rotaDetalhar: action.rotaDetalhar };
    }
    return state;
}
